import { render, staticRenderFns } from "./advertApplication.vue?vue&type=template&id=b90aa5f8&scoped=true&"
import script from "./advertApplication.vue?vue&type=script&lang=ts&"
export * from "./advertApplication.vue?vue&type=script&lang=ts&"
import style0 from "./advertApplication.vue?vue&type=style&index=0&id=b90aa5f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90aa5f8",
  null
  
)

export default component.exports